module.exports = __webpack_public_path__ + "media/2.8ebb353b.mp3";